var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'rounded overflow-hidden shadow-lg bg-white border-gray-300': true,
    'rounded-b-none': _vm.noBottomRadius,
    'rounded-t-none': _vm.noTopRadius
  }},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"px-3 py-3 px-md-4 py-md-4 border-b"},[_vm._t("header")],2):_vm._e(),_c('div',{class:{
      'w-full': true,
      'px-4 py-4 px-md-4 py-md-4': !_vm.isNoPadding
    }},[_vm._t("main")],2),(_vm.hasFooterSlot)?_c('div',{staticClass:"border-t px-2 py-2 px-md-4 py-md-4"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }